import React, { useEffect } from "react";
import CardPedido from "../../../../cardPedido/.mixins/index";
import { Dialog, IconButton, Typography, CircularProgress } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import MUIDataTable from "mui-datatables";

//css
import Styles from "./styles";
const useStyles = Styles();

export default (params) => {
    const classes = useStyles();
    useEffect(() => {
        params.loadDataModal ? params.loadDataModal(params) : null;
    }, []);

    function HeaderModal(params) {
        const descriptions = params.state.descriptionsModalTable;

        return (
            <div>
                <Typography>
                    <IconButton
                        aria-label="close"
                        onClick={params.handleDialogModalTable}
                        className={classes.closeButton}
                    >
                        <CloseIcon />
                    </IconButton>
                    <CardPedido {...descriptions} />
                </Typography>
            </div>
        );
    }

    function TableModal(params) {
        return (
            <div>
                <MUIDataTable
                    maxWidth={"md"}
                    data={params.state.itensTable}
                    columns={params.state.columns}
                    options={{
                        title: false,
                        print: false,
                        filter: false,
                        download: false,
                        search: false,
                        viewColumns: false,
                        selectableRows: "none",
                        size: "small",
                        responsive: "scrollFullHeight",
                        rowsPerPage: 4,
                        rowsPerPageOptions: false,
                    }}
                />
            </div>
        );
    }

    return (
        <div>
            <Dialog open={params.state.isOpenModalTable} fullWidth maxWidth={"md"}>
                <HeaderModal {...params} />
                {params.state.isLoading && (
                    <div className={classes.loaderSpace} align="center">
                        <CircularProgress />
                        <p>Carregando Dados...</p>
                    </div>
                )}
                {!params.state.isLoading && <TableModal {...params} />}
                {params.state.FooterModal && <params.state.FooterModal {...params} />}
            </Dialog>
        </div>
    );
};
